
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';

	@Component({})
	export default class AboutMenu extends BaseView {


	}

